import { gql, useQuery } from '@apollo/client';

export const PO_TRANSACTION_LIST_QUERY = gql`
  query PoTransactionList(
    $page: Int!
    $pageSize: Int!
    $poSaleOrderId: Int
    $shipperId: Int
    $shipperIds: [Int!]
    $distributorIds: [Int!]
    $status: String
    $startDate: Date
    $endDate: Date
    $ngayDatHangStartDate: Date
    $ngayDatHangEndDate: Date
    $filter: String
    $heThongMT: [String!]
    $createdStartDate: Date
    $createdEndDate: Date
    $creatorFilter: String
    $excludeMisaInventoryIssue: Boolean
    $excludeMisaInvoice: Boolean
    $includeOnlyMisaInvoice: Boolean
  ) {
    poSaleOrder {
      poTransactions(
        page: $page
        pageSize: $pageSize
        poSaleOrderId: $poSaleOrderId
        shipperId: $shipperId
        shipperIds: $shipperIds
        distributorIds: $distributorIds
        status: $status
        startDate: $startDate
        endDate: $endDate
        ngayDatHangStartDate: $ngayDatHangStartDate
        ngayDatHangEndDate: $ngayDatHangEndDate
        filter: $filter
        heThongMT: $heThongMT
        createdStartDate: $createdStartDate
        createdEndDate: $createdEndDate
        creatorFilter: $creatorFilter
        excludeMisaInventoryIssue: $excludeMisaInventoryIssue
        excludeMisaInvoice: $excludeMisaInvoice
        includeOnlyMisaInvoice: $includeOnlyMisaInvoice
      ) {
        total
        data {
          id
          poSaleOrderId
          shipperId
          status
          nguoiNhanHang
          ngayGiaoHang
          lyDoKhongPhatDuoc
          ngayDVVCLayHang
          tienCOD
          trongLuongTinhCuocKg
          soKien
          phiShip
          phiHoanTra
          noiDungKhac
          dain
          isMisaInventoryIssue
          isMisaInvoice
          createdAt
          modifiedAt
          creator {
            id
            name
          }
          modifiedBy {
            id
            name
          }
          poSaleOrder {
            id
            cd
            orderDate
            ngayDatHang
            deliveryAddress
            receiver
            customer {
              id
              cd
              name
              address1
              phone11
              taxCode
            }
            distributor {
              id
              cd
              name
            }
          }
          shipper {
            id
            cd
            name
          }
          items {
            id
            productId
            unitId
            soLuongGuiGiao
            soLuongGiaoThanhCong
            isFree
            donGia
            thanhTienTruocCK
            chietKhau
            thanhTien
            product {
              id
              cd
              name
              barcode
              otherReference
              tKDoanhThuCo
              salesUnit {
                id
                cd
              }
            }
            unit {
              id
              cd
            }
          }
        }
      }
    }
  }
`;

export interface PoTransactionListQueryVariables {
  page: number;
  pageSize: number;
  poSaleOrderId?: number;
  shipperId?: number;
  shipperIds?: number[];
  distributorIds?: number[];
  status?: string;
  startDate?: string;
  endDate?: string;
  ngayDatHangStartDate?: string;
  ngayDatHangEndDate?: string;
  filter?: string;
  heThongMT?: string[];
  createdStartDate?: string;
  createdEndDate?: string;
  creatorFilter?: string;
  excludeMisaInventoryIssue?: boolean;
  excludeMisaInvoice?: boolean;
  includeOnlyMisaInvoice?: boolean;
}

export const usePoTransactionListQuery = (options?: any) =>
  useQuery(PO_TRANSACTION_LIST_QUERY, options);

